<template>
  <div class="container">
    <vue-dialog
      :color="data_color"
      v-if="show_dialog"
      :name="data_name"
      :left="data_left"
      :right="data_right"
      :title="data_title"
      :value="data_value"
      @dialog_end="dialogend"
    >
    </vue-dialog>
    <div class="top">
      <div class="back-arrow" @click="$emit('back-step', 1)">
        <img src="../../assets/images/desktop/back_passive.svg" alt="" />
      </div>
      {{ uppercase(main_data.typ_house_tip.title) }}
    </div>
    <div class="middle">
      <div class="row-container" @mouseleave="reset_hover">
        <div class="row">
          <div
            v-for="(key, index) in Object.keys(get_house_images).slice(0, 5)"
            :class="{ house: true, choosed: choosed === index + 1 }"
            :key="'house' + index"
            @mouseenter="hover_house(index + 1, key)"
            @click="choose_house(index + 1, key)"
          >
            <img v-if="choosed === index + 1" class="stikla" src="../../assets/images/desktop/stikla_bela.svg" />
            <img :src="get_house_images[key]" />
          </div>
        </div>
        <div class="row">
          <div
            v-for="(key, index) in Object.keys(get_house_images).slice(5)"
            :class="{ house: true, choosed: choosed === index + 6 }"
            :key="'house' + (index + 6)"
            @mouseenter="hover_house(index + 6, key)"
            @click="choose_house(index + 6, key)"
          >
            <img v-if="choosed === index + 6" class="stikla" src="../../assets/images/desktop/stikla_bela.svg" />
            <img :src="get_house_images[key]" />
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div :class="{ button: true, active: choosed !== -1 }" @click="confirm_step">
        {{ main_data.app_next.title }}
      </div>
      <div v-if="initial_setup" class="text" @click="$emit('back-step', 1)">
        {{ main_data.app_back.title }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  .top {
    margin-top: 1.2rem;
    font-family: F-Dem;
    font-size: 3.4rem;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: center;
    color: $text_white;
    flex-grow: 0;
    position: relative;
    width: 100%;
    height: 4.6rem;

    .back-arrow {
      position: absolute;
      left: 3rem;
      width: 6.4rem;
      height: 6.4rem;
      border-radius: 50%;
      top: -0.9rem;
      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        background-color: $main_header_middle;
      }

      img {
        width: 3rem;
        max-width: 3rem;
      }
    }
  }

  .middle {
    margin-left: 63.8rem;

    .row-container {
      width: min-content;
      margin: auto;

      .row {
        display: flex;

        .house {
          width: 20.7rem;
          height: 20.7rem;
          border-radius: 10.35rem;
          background-color: $main_header;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          cursor: pointer;

          &:not(:last-child) {
            margin-right: 1rem;
          }

          &:hover:not(.choosed) {
            background-color: $main_header_middle;
          }

          &.choosed {
            background-color: $desktop_button_inactive;
          }

          img:not(.stikla) {
            width: 100%;
            height: 100%;
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
          }

          .stikla {
            position: absolute;
            z-index: 1;
            top: 0.5rem;
            right: 0.5rem;
            width: 5.4rem;
            height: 5.4rem;
          }
        }
      }
    }
  }

  .bottom {
    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto 1.1rem auto;
      background-color: $desktop_button_inactive;
      height: 7rem;
      width: 26.4rem;
      border-radius: 3.5rem;
      font-size: 2.5rem;
      line-height: 1.16;
      color: $desktop_button_text_inactive;
      flex-grow: 0;

      &.active {
        background-color: $desktop_green;
        color: $text_white;
        cursor: pointer;
      }
    }

    .text {
      font-size: 2.1rem;
      line-height: 1.19;
      text-align: center;
      color: $desktop_text_inactive;
      cursor: pointer;
    }
  }
}
</style>

<script>
import mixin from "../../lib/mixins.js";
import dialog from "../../components/dialog";
import superconsole from "../../lib/superconsole.js";

export default {
  mixins: [mixin],
  props: ["main_data", "get_intervention_exists", "house_selected", "initial_setup"],
  components: {
    "vue-dialog": dialog,
  },
  computed: {
    get_house_images: function () {
      let filtered = {};
      for (const prop in this.main_data.typ_house.data) {
        const key = prop + "_d2";
        if (this.main_data.typ_house.images.hasOwnProperty(key)) {
          if (key.substring(key.length - 3) === "_d2") {
            filtered[key.substring(0, key.length - 3)] = this.main_data.typ_house.images[key];
          }
        }
      }
      return filtered;
    },
  },
  data: function () {
    return {
      choosed: -1,
      hovered: 1,
      show_dialog: false,
      data_title: "",
      data_name: "",
      data_left: "",
      data_right: "",
      data_color: "",
      data_value: {},
      promise: null,
    };
  },
  methods: {
    confirm_step: function () {
      if (this.choosed != -1) {
        this.emit_choosed();
        this.$emit("confirm-step", 1);
      }
    },
    hover_house: function (hover, key) {
      this.hovered = hover;
      this.$emit("set-current-house", {
        index: hover,
        key: key,
        value: this.get_house_images[key].substr(9, 2),
      });
    },
    emit_choosed: function () {
      const key = Object.keys(this.get_house_images)[this.choosed - 1];
      this.$emit("set-current-house", {
        index: this.choosed,
        key: key,
        value: this.get_house_images[key].substr(9, 2),
      });
    },
    reset_hover: function () {
      this.hovered = -1;
      if (this.choosed !== -1) {
        this.emit_choosed();
      }
    },
    choose_house: async function (choose, key) {
      if (await this.valuechange("typ_house", key)) {
        this.choosed = choose;
        this.$emit("set-current-house", {
          index: choose,
          key: key,
          value: this.get_house_images[key].substr(9, 2),
        });
      }
    },
    pre_approve: async function (name, value) {
      return new Promise((res) => {
        this.promise = res;
        this.dialogstart(name, value);
      });
    },
    dialogstart: async function (name, value) {
      const showDialog = (title, intervention, color = "#24c46c") => {
        this.data_title = title;
        this.data_left = this.main_data.app_proceed.title;
        this.data_right = this.main_data.app_cancel.title;
        this.data_value = { name: name, value: value };
        this.data_name = intervention;
        this.show_dialog = true;
        this.data_color = color;
      };

      if (
        this.main_data.typ_override_window_manual.value ||
        this.main_data.typ_override_roof_window_manual.value ||
        this.get_intervention_exists
      ) {
        if (
          (this.main_data.typ_override_window_manual.value || this.main_data.typ_override_roof_window_manual.value) &&
          this.get_intervention_exists
        ) {
          showDialog(this.main_data.app_intervention_all_reset.title, "all");
        } else if (
          this.main_data.typ_override_window_manual.value ||
          this.main_data.typ_override_roof_window_manual.value
        ) {
          showDialog(this.main_data.typ_window_delete.title);
        } else {
          showDialog(this.main_data.app_intervention_reset.title, "all");
        }
      } else {
        this.promise(true);
      }
    },
    dialogend: function (ev) {
      if (ev.confirm) {
        this.$emit("reset_whole_intervention");
        this.promise(true);
      } else {
        this.promise(false);
      }

      this.show_dialog = false;
    },
    valuechange: async function (name, value, isnumber, approved) {
      if (isnumber) {
        value = +value;
      }

      if (!approved) {
        if (!(await this.pre_approve(name, value))) return false;
      }

      // eslint-disable-next-line
      superconsole.log("emit", name, value);

      this.$emit("value-change", {
        name: name,
        value: value,
      });

      return true;
    },
  },
  mounted: function () {
    this.choosed = this.house_selected
      ? Object.keys(this.get_house_images).indexOf(this.main_data.typ_house.value) + 1
      : -1;
  },
};
</script>
